import { create } from "zustand";
import { persist } from "zustand/middleware";

export enum PannelEnum {
  FavoritesList = "FavoritesList",
  RangerChat = "RangerChat",
}

interface SidebarState {
  currentPanel: PannelEnum;
  setCurrentPanel: (panel: PannelEnum) => void;
  isFullscreen: boolean;
  setIsFullscreen: (isFullscreen: boolean) => void;
}

const useSidebarStore = create<SidebarState>()(
  persist(
    // let's go ahead and persist the state
    set => ({
      currentPanel: PannelEnum.RangerChat,
      setCurrentPanel: (panel: PannelEnum) => set({ currentPanel: panel }),
      isFullscreen: false,
      setIsFullscreen: (isFullscreen: boolean) => set({ isFullscreen }),
    }),
    {
      name: "sidebar-store", // Key for localStorage
    }
  )
);

export default useSidebarStore;
